import { ReactNode } from "react";

export function Breadcrumbs(props: { children: ReactNode[] }) {
  return (
    <>
      {props.children.map((item, index) => (
        <small key={index} className="me-1">
          {item} {index < props.children.length - 1 && "/"}
        </small>
      ))}
    </>
  );
}
